import React from 'react';
import './listPage.css';

/**
 * Κατάσταση σε μια γραμμή (Ενεργός, Αναπάντητη, Σε εκκρεμότητα): μικρή ετικέτα κειμένου με απαλό φόντο,
 * χωρίς εικονίδιο — το νόημα το λέει πάντα το κείμενο, όχι μόνο το χρώμα. Πράσινο/πορτοκαλί/κόκκινο
 * μόνο για ok/warn/danger· «brand» για το «νέο/επιλεγμένο», «muted» για ό,τι δεν μετρά (Ανενεργός, —).
 * Στη στοίβα του στενού πίνακα χάνει το φόντο και μένει χρωματιστό κείμενο μέσα στη γραμμή meta.
 */

export type ChipTone = 'ok' | 'warn' | 'danger' | 'muted' | 'brand';

export interface StatusChipProps {
  tone: ChipTone;
  children: React.ReactNode;
  title?: string;
  testId?: string;
}

export const StatusChip: React.FC<StatusChipProps> = ({ tone, children, title, testId }) => (
  <span className="lp-chip" data-tone={tone} title={title} data-testid={testId}>{children}</span>
);

export default StatusChip;
